export default "__VITE_ASSET__BZf3kFv8__"